export default {"src":"/_next/static/media/ammunition_cat_ic.0fe29ea7.svg","height":120,"width":120};